/**
 * Stats Animation
 *
 * Animates the stats numbers when the section is scrolled into view.
 */
document.addEventListener( 'DOMContentLoaded', function() {
	const statsWrapper = document.querySelector( '.stats-wrapper' );

	if ( ! statsWrapper ) {
		return;
	}

	// Only apply animation if animation-on class is present
	if ( ! statsWrapper.classList.contains( 'animation-on' ) ) {
		return;
	}

	const animateValue = ( obj, start, end, duration, prefix, suffix, originalNumberString ) => {
		let startTimestamp = null;
		const isFloat = originalNumberString.includes( '.' );
		const decimalPlaces = isFloat ? originalNumberString.split( '.' )[ 1 ].length : 0;

		const step = ( timestamp ) => {
			if ( ! startTimestamp ) {
				startTimestamp = timestamp;
			}
			const progress = Math.min( ( timestamp - startTimestamp ) / duration, 1 );
			const currentValue = ( progress * ( end - start ) ) + start;

			let animatedNumber;
			if ( isFloat ) {
				animatedNumber = currentValue.toFixed( decimalPlaces );
			} else {
				animatedNumber = Math.floor( currentValue ).toLocaleString();
			}

			obj.innerHTML = prefix + animatedNumber + suffix;

			if ( progress < 1 ) {
				window.requestAnimationFrame( step );
			} else {
				obj.innerHTML = prefix + originalNumberString + suffix;
			}
		};
		window.requestAnimationFrame( step );
	};

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					const stats = entry.target.querySelectorAll( '.stats-blocks span' );
					stats.forEach( ( stat ) => {
						const originalText = stat.textContent;
						const match = originalText.match( /[\d,.]+/ );

						if ( ! match ) {
							return;
						}

						const numberString = match[ 0 ];
						const endValue = parseFloat( numberString.replace( /,/g, '' ) );

						if ( isNaN( endValue ) ) {
							return;
						}

						const numberIndex = match.index;
						const prefix = originalText.substring( 0, numberIndex );
						const suffix = originalText.substring( numberIndex + numberString.length );

						animateValue( stat, 0, endValue, 2000, prefix, suffix, numberString );
					} );
					observer.unobserve( entry.target );
				}
			} );
		},
		{
			threshold: 0.5,
		}
	);

	observer.observe( statsWrapper );
} ); 